import * as Yup from 'yup';

// Validation schemas
const chargeValidationSchema = Yup.object().shape({
  type: Yup.string().required('Charge type is required'),
  value: Yup.number().required('Charge value is required').min(0, 'Charge value must be at least 0'),
});

const discountValidationSchema = Yup.object().shape({
  type: Yup.string().required('Discount type is required'),
  value: Yup.number().required('Discount value is required').min(0, 'Discount value must be at least 0'),
});

const taxValidationSchema = Yup.object().shape({
  type: Yup.string().required('Tax type is required'),
  value: Yup.number().required('Tax value is required').min(0, 'Tax value must be at least 0'),
  category: Yup.object().required('Tax category is required'),
});

const taxExemptionValidationSchema = Yup.object()
  .shape({
    amount: Yup.number().min(0, 'Amount must be at least 0'),
    tax: Yup.number().min(0, 'Amount must be at least 0'),
    reason: Yup.string()
      .nullable()
      .test('is-required-if-other-present', 'Reason of Tax Exemption is required', function (value) {
        const { amount } = this.parent;
        return amount <= 0 || value;
      }),
  })
  .test('valid-tax-exemption', 'Tax exemption amount must be less than base amount', function (value) {
    const { unit_rate, quantity } = this.parent;
    const baseAmount = (unit_rate || 0) * (quantity || 0);
    return value?.amount <= baseAmount;
  });

const lineItemValidationSchema = Yup.object().shape({
  item_code: Yup.object().required('Item classification code is required'),
  description: Yup.string().min(1).max(300).required('Description is required'),
  unit_of_measure: Yup.object().required('UOM code is required'),
  quantity: Yup.number().required('Quantity is required').moreThan(0, 'Quantity must be more than 0'),
  unit_rate: Yup.number().required('Unit rate is required').min(0, 'Unit rate must be at least 0'),
  discount_amount: Yup.number().required('Discount is required').min(0, 'Discount must be at least 0'),
  charge_amount: Yup.number().required('Charge is required').min(0, 'Charge must be at least 0'),
  tax_amount: Yup.number().required('Tax is required').min(0, 'Tax must be at least 0'),
  discounts: Yup.array().of(discountValidationSchema),
  charges: Yup.array().of(chargeValidationSchema),
  taxes: Yup.array().of(taxValidationSchema),
  tax_exemption: taxExemptionValidationSchema,
});

const productVaidationSchema = Yup.object().shape({
  item_code: Yup.object().required('Item classification code is required'),
  quantity: Yup.number().required('Quantity is required').min(1, 'Quantity must be at least 1'),
  description: Yup.string().min(1).max(300).required('Description is required'),
  unit_of_measure: Yup.object().required('UOM code is required'),
  unit_rate: Yup.number().required('Unit rate is required').min(0, 'Unit rate must be at least 0'),
  taxes: Yup.array().of(taxValidationSchema),
});

const NotesValidationSchema = Yup.object().shape({
  notes: Yup.string().max(1000, 'Notes cannot be more than 1000 characters'),
});

export {
  chargeValidationSchema,
  discountValidationSchema,
  taxValidationSchema,
  lineItemValidationSchema,
  productVaidationSchema,
  NotesValidationSchema,
};
